
import { useState, useEffect, createContext } from 'react';
import { getAuthenticatedUser, getCustomAttributes } from 'cognito/auth';

const CurrentUserContext = createContext ();

function RequiresCurrentUserContext ( { children } ) 
{
    const [ isLoadedUser, setIsLoadedUser ] = useState ( false );
    const [ isLoadedCustomAttributes, setIsLoadedCustomAttributes ] = useState ( false );
    const [ currentUser, setCurrentUser ] = useState ( null );
    const [ customAttributes, setCustomAttributes ] = useState ( null );

    const doGetCurrentUser = async () => {

        try
        {
            const result = await getAuthenticatedUser ();

            setIsLoadedUser ( true );
            setCurrentUser ( result );
        }
        catch ( error )
        {
            console.log ( error );
            setCurrentUser ( null );
            setIsLoadedUser ( true );
        }
    }

    const doGetCustomAttributes = async () => {

        try
        {
            const result = await getCustomAttributes ();

            setIsLoadedCustomAttributes ( true );
            setCustomAttributes ( result );
        }
        catch ( error )
        {
            console.log ( error );
            setCustomAttributes ( null );
            setIsLoadedCustomAttributes ( true );
        }
    }
   
    useEffect ( () => {

        if ( currentUser === null && isLoadedUser === false )
        {
            doGetCurrentUser ();
        }

    }, [ currentUser, isLoadedUser ] );
   
    useEffect ( () => {

        if ( customAttributes === null && isLoadedCustomAttributes === false )
        {
            doGetCustomAttributes ();
        }

    }, [ customAttributes, isLoadedCustomAttributes ] );

    const clearState = () =>
    {
        setCurrentUser ( null );
        setCustomAttributes ( null );
    }

    const clearIsLoaded = () =>
    {
        setIsLoadedUser ( false );
        setIsLoadedCustomAttributes ( false );
    }

    return  <CurrentUserContext.Provider value={ { currentUser: currentUser, 
                                                    customAttributes: customAttributes,
                                                    onLoggedIn: () => clearIsLoaded (), 
                                                    onLoggedOut: () => clearState (),
                                                    reloadCustomAttributes: () => doGetCustomAttributes () } }>
                {children}
            </CurrentUserContext.Provider>
}

export { CurrentUserContext, RequiresCurrentUserContext }
